/* eslint-disable react/no-array-index-key */
import React from 'react';
import { FieldArray, Field, connect } from 'formik';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import FieldContextFeeder from '../components/FieldContextFeeder';
import Error from '../components/Error';

import { FormLabel as Label } from '~ui-kit';

import SelectWithCount from '../components/SelectWithCount';
import TextInput from '../components/TextInput';

import binSVG from '~images/Pake_peruuta_sin.svg';
import plusSVG from '~images/ikoni_lisaa.svg';

const SelectWithCountField = props => {
  const { values, setFieldValue } = props.formik;
  const isDesktop = useSelector(state => state.reducer.isDesktop);

  const { label, required, addLabel } = props;
  const name = props.id || props.name;

  return (
    <Container>
      <FieldArray
        name={name}
        render={arrayHelpers => {
          return (
            <RowContainer mobile={!isDesktop}>
              {values[props.name].map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <Field name={`${props.name}.${index}`}>
                      {({
                        field,
                        // form: { touched, errors },
                        meta,
                      }) => (
                        <SelectContainer>
                          <SelectWithCount
                            {...field}
                            required={required}
                            label={label}
                            options={props.options}
                            onChange={option => {
                              setFieldValue(`${props.name}.${index}`, option);
                              if (props.onChange) props.onChange(option);
                            }}
                            error={meta.touched && meta.error}
                          />
                          {item?.id?.requireComment && (
                            <CommentContainer>
                              <CommentLabel required>Tarkennus:</CommentLabel>
                              <Comment
                                type="text"
                                className="form-control"
                                placeholder="Kirjoita kaasupullon tyyppi"
                                value={item.id.comment}
                                onChange={event => {
                                  const newItem = {
                                    ...item,
                                    id: {
                                      ...item.id,
                                      comment: event.target.value,
                                    },
                                  };
                                  setFieldValue(
                                    `${props.name}.${index}`,
                                    newItem
                                  );
                                  if (props.onChange) props.onChange(newItem);
                                }}
                              />
                            </CommentContainer>
                          )}
                          {meta.touched && meta.error && (
                            <Error>{meta.error}</Error>
                          )}
                        </SelectContainer>
                      )}
                    </Field>

                    {index > 0 ? (
                      <Remove
                        type="button"
                        onClick={() => arrayHelpers.remove(index)}
                      >
                        <Bin src={binSVG} alt="Poista kenttä" />
                        {isDesktop && <RemoveLabel>Poista kenttä</RemoveLabel>}
                      </Remove>
                    ) : (
                      <Filler />
                    )}
                  </React.Fragment>
                );
              })}
              <AddContainer>
                <Add
                  type="button"
                  onClick={() =>
                    arrayHelpers.push({ id: null, itemCount: '1' })
                  }
                >
                  <Plus src={plusSVG} alt={addLabel || 'Lisää kenttä'} />
                  <AddLabel>{addLabel || 'Lisää kenttä'}</AddLabel>
                </Add>
              </AddContainer>
            </RowContainer>
          );
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  // max-width: var(--field-width);
`;

const Remove = styled.button`
  display: flex;
  align-items: flex-end;
  margin-bottom: 9px;
  margin-left: 14px;
`;

const RemoveLabel = styled.div`
  color: var(--lighterBlue);
  margin-left: 8px;
`;

const Bin = styled.img`
  height: 22px;
`;

const AddContainer = styled.div``;

const Add = styled.button`
  display: flex;
  align-items: center;
`;

const AddLabel = styled.div`
  color: var(--lighterBlue);
  margin-left: 8px;
`;

const Plus = styled.img`
  height: 22px;
`;

const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr ${p => (p.mobile ? '36px' : '145px')};
  gap: 24px;
`;

const Filler = styled.div``;

const SelectContainer = styled.div`
  flex-grow: 1;
`;

const Comment = styled(TextInput)``;

const CommentContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

const CommentLabel = styled(Label)`
  margin-bottom: 0;
  margin-right: 8px;
`;

export default FieldContextFeeder(connect(SelectWithCountField));
